var React = require('react');

function ChevronRightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.5 17a1 1 0 01-.71-.29 1 1 0 010-1.42L13.1 12 9.92 8.69a1 1 0 010-1.41 1 1 0 011.42 0l3.86 4a1 1 0 010 1.4l-4 4a1 1 0 01-.7.32z"}));
}

ChevronRightInline.defaultProps = {"viewBox":"9.494202613830566 6.9842023849487305 5.991655349731445 10.015814781188965"};

module.exports = ChevronRightInline;

ChevronRightInline.default = ChevronRightInline;
